"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLanguage = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
// Начальное состояние языка
var initialState = {
    currentLanguage: 'en' // Устанавливаем английский язык по умолчанию
};
// Создаем слайс для языка
var localisationSlice = (0, toolkit_1.createSlice)({
    name: 'language',
    initialState: initialState,
    reducers: {
        setLanguage: function (state, action) {
            state.currentLanguage = action.payload;
        }
    }
});
// Экспортируем действия и редуктор
exports.setLanguage = localisationSlice.actions.setLanguage;
exports.default = localisationSlice.reducer;
